/**
 * Used as a better-supported alternative to `Promise.withResolvers()`
 */
class Deferred<T = void> {
  public promise: Promise<T>

  // @ts-expect-error Definitely assigned in the constructor
  public resolve: (value: T | PromiseLike<T>) => void

  // @ts-expect-error Definitely assigned in the constructor
  public reject: (reason?: any) => void

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }
}

/**
 * Returns a `{ promise, resolve, reject }` triple. Uses the native `Promise.withResolvers()`
 * (Node 22+, modern browsers) when available and falls back to a `Deferred` instance otherwise.
 * @template T - Resolution value type. Defaults to `void`.
 * @returns Object with the deferred `promise` and its `resolve` / `reject` callbacks.
 * @category Utils
 */
export const promiseWithResolvers = <T = void>() => 'withResolvers' in Promise ? Promise.withResolvers<T>() : new Deferred<T>()
